import { Alert } from '@mui/material';
import React from 'react';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class TemplatePreviewErrorBoundary extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(
      'TemplatePreviewErrorBoundary caught an error:',
      error,
      errorInfo,
    );
  }

  render() {
    const { hasError } = this.state;
    const { fallback, children } = this.props;

    if (hasError) {
      return (
        fallback || (
          <Alert severity="error" sx={{ m: 2 }}>
            <div>
              <strong>Template Preview Error</strong>
              <br />
              Unable to display template preview. The template will still work
              when you proceed with sending the letter.
            </div>
          </Alert>
        )
      );
    }

    return children;
  }
}
